import DestinationGroups from '../components/templates';

export const DestinationGroupsContainer = () => {
  return <DestinationGroups />;
};
